package fr.xibalba.generateurClassesLycee

import com.juul.indexeddb.Database
import com.juul.indexeddb.Key
import com.juul.indexeddb.openDatabase
import kotlinx.serialization.json.Json

suspend fun openDatabase(): Database {
    return openDatabase("classesCsvStore", 2) { database, oldVersion, _ ->
        if (oldVersion < 1) {
            database.createObjectStore("files")
        }
        if (oldVersion < 2) {
            database.createObjectStore("rawPatches")
        }
    }
}

private val fileKey = Key("file")

suspend fun saveFileToIndexedDB(fichier: Fichier) {
    println("Saving file to IndexedDB: ${fichier.name} with content length: ${fichier.content.length}")
    val database = openDatabase()
    database.writeTransaction("files") {
        val store = objectStore("files")
        store.put(Json.encodeToString(fichier), fileKey)
    }
    println("File saved to IndexedDB: ${fichier.name}")
}

suspend fun loadFileFromIndexedDB(): Fichier? {
    try {
        val database = openDatabase()
        return database.transaction("files") {
            val json = objectStore("files").get(fileKey) as? String ?: return@transaction null
            Json.decodeFromString<Fichier>(json)
        }
    } catch (err: Exception) {
        err.printStackTrace()
        return null
    }
}

suspend fun deleteFileFromIndexedDB() {
    val database = openDatabase()
    database.writeTransaction("files") {
        val store = objectStore("files")
        store.delete(fileKey)
    }
}

suspend fun saveRawPatchesToIndexedDB(fileHash: String, rawPatches: Map<Int, String>) {
    println("Saving raw patches to IndexedDB for file: $fileHash")
    val database = openDatabase()
    database.writeTransaction("rawPatches") {
        val store = objectStore("rawPatches")
        store.put(Json.encodeToString(rawPatches), Key(fileHash))
    }
    println("Raw patches saved to IndexedDB for file: $fileHash")
}

suspend fun loadRawPatchesFromIndexedDB(fileHash: String): Map<Int, String>? {
    try {
        val database = openDatabase()
        return database.transaction("rawPatches") {
            val json = objectStore("rawPatches").get(Key(fileHash)) as? String ?: return@transaction null
            Json.decodeFromString<Map<Int, String>>(json)
        }
    } catch (err: Exception) {
        err.printStackTrace()
        return null
    }
}